import { Button } from '@headlessui/react'
import React from 'react'

import { AudioControlPanel } from '@/components/common/AudioPlayer'
import { FileUploadItem, MultiFileUploader } from '@/components/file'
import Autocomplete from '@/components/FormInteraction/Autocomplete'
import type { FileUploadResponse } from '@/services/StorageService'

interface DemoProps {
  children?: React.ReactNode
}
const Demo: React.FC<DemoProps> = () => {

  const handleFilesChange = (newFiles: FileUploadItem[]) => {
    console.log('文件列表更新:', newFiles)
  }

  const handleUploadComplete = (results: FileUploadResponse[]) => {
    console.log('上传完成:', results)
  }

  return (
    <>

      <AudioControlPanel showControls={true} />

      {/* 基础用法 */}
      <div className="mb-8">
        <h2 className="text-lg font-semibold mb-4">基础用法（手动上传）</h2>
        <MultiFileUploader
          onFilesChange={handleFilesChange}
          onUploadComplete={handleUploadComplete}
          accept="image/*,.pdf"
          maxSize={5 * 1024 * 1024} // 5MB
          maxFiles={5}
          folder="examples"
          autoUpload={false}
          enableUpload={true}
        />
      </div>

      <Autocomplete
        onChange={() => {}}
        options={[
          { label: '北京市', value: 'beijing' },
          { label: '上海市', value: 'shanghai' },
          { label: '广州市', value: 'guangzhou' },
          { label: '深圳市', value: 'shenzhen' },
          { label: '杭州市', value: 'hangzhou' },
          { label: '成都市', value: 'chengdu' },
          { label: '重庆市', value: 'chongqing' },
          { label: '西安市', value: 'xian' },
          { label: '南京市', value: 'nanjing' },
          { label: '武汉市', value: 'wuhan' }
        ]}
      />
    </>
  )
}

export default Demo
